module.exports = __webpack_public_path__ + "5c9aeb39b2b1c21d6fdb99492f81d397.png";